(() => {
  const mobileQuery = window.matchMedia("(max-width: 749px)");

  const PRODUCT_STORIES = {
    "individual-5oz-bar-of-fragrance-free": {
      subtitle: "For skin that feels dry, tight, or easily irritated after washing.",
      kicker: "Why skin can feel dry after washing",
      copy: "Traditional soap is typically pH 9–11. HARP® pairs skin-friendly pH 5.0–6.0 with a soap-free 100% syndet cleansing system designed to respect the skin’s moisture barrier.",
      note: "Mildness depends on the full formula—not pH alone. HARP combines skin-friendly pH with modern syndet cleansing chemistry."
    },
    "individual-5oz-bar-of-fresh-sport-fragrance": {
      subtitle: "For a fresh, clean-feeling wash without the stripped after-feel.",
      kicker: "Fresh clean feel. Modern cleansing chemistry.",
      copy: "Traditional soap is typically pH 9–11. HARP® Fresh Sport combines skin-friendly pH 5.0–6.0 with a soap-free 100% syndet cleansing system and a crisp clean scent for comfortable daily cleansing.",
      note: "Mildness depends on the complete formula—not pH alone. HARP combines skin-friendly pH with soap-free syndet cleansing chemistry."
    },
    "individual-5oz-bar-of-alluring-floral-fragrance": {
      subtitle: "For a softer, more comfortable cleanse with a gentle vanilla-lavender scent.",
      kicker: "Soft scent. Soap-free cleansing chemistry.",
      copy: "Traditional soap is typically pH 9–11. HARP® Vanilla Lavender pairs skin-friendly pH 5.0–6.0 with a soap-free 100% syndet cleansing system and a soft vanilla-lavender scent for comfortable daily cleansing.",
      note: "Mildness depends on the complete formula—not pH alone. HARP combines skin-friendly pH with soap-free syndet cleansing chemistry."
    },
    "harp-anti-aging-body-wash-bar-with-retinol-serum-niacinamide-vitamin-e-hyaluronic-acid-100-syndet-base-soap-lye-free-and-fragrance-free": {
      subtitle: "Skin-care-forward cleansing with retinol, niacinamide, hyaluronic acid, and vitamin E.",
      kicker: "Cleansing chemistry + skin-care ingredients",
      copy: "Traditional soap is typically pH 9–11. HARP® Anti-Aging uses a soap-free 100% syndet cleansing system at pH 5.0–6.0, plus retinol, niacinamide, hyaluronic acid, and vitamin E for a more skin-care-forward body cleansing routine.",
      note: "Mildness and skin feel depend on the complete formula—not pH or any single active alone."
    },
    "harp-ph-balanced-5-0-6-0-exfoliating-body-wash-bar-fragrance-free-ground-bamboo-exfoliation-the-perfect-consistency-soap-lye-preservative-dye-masking-agent-free": {
      subtitle: "Gentle exfoliation with fine bamboo powder in a soap-free, pH-balanced cleansing bar.",
      kicker: "Exfoliation without traditional soap chemistry",
      copy: "Traditional soap is typically pH 9–11. HARP® Exfoliating combines skin-friendly pH 5.0–6.0, a soap-free 100% syndet cleansing system, and fine bamboo powder designed to help smooth rough-feeling skin while cleansing.",
      note: "Exfoliation and mildness depend on the complete formula and how often the bar is used."
    }
  };

  function initializeStickyButton() {
    const stickyButtons = document.querySelectorAll(".harp-ff-sticky-buy");

    stickyButtons.forEach((sticky) => {
      const stickyButton = sticky.querySelector("button");
      const stickyLabel = stickyButton?.querySelector("span");
      const productFormId = stickyButton?.getAttribute("form");
      const productForm = productFormId ? document.getElementById(productFormId) : null;
      const productWrapper = sticky.closest(".harp-ff-product") || document;
      const mainSubmit =
        productForm?.querySelector('button[type="submit"]') ||
        productWrapper.querySelector(".product-form__submit");

      if (!stickyButton || !stickyLabel) return;

      const syncStickyButton = () => {
        if (!mainSubmit) {
          stickyLabel.textContent = "Add to cart";
          return;
        }

        const unavailable =
          mainSubmit.disabled ||
          mainSubmit.getAttribute("aria-disabled") === "true";
        const mainText = mainSubmit.textContent.trim().toLowerCase();

        stickyButton.disabled = unavailable;
        stickyButton.setAttribute("aria-disabled", unavailable ? "true" : "false");

        if (unavailable) {
          stickyLabel.textContent = mainText.includes("sold out")
            ? "Sold out"
            : "Unavailable";
        } else {
          stickyLabel.textContent = "Add to cart";
        }
      };

      syncStickyButton();

      if (mainSubmit) {
        new MutationObserver(syncStickyButton).observe(mainSubmit, {
          attributes: true,
          childList: true,
          subtree: true,
        });
      }

      productWrapper.addEventListener("change", () => {
        window.setTimeout(syncStickyButton, 50);
      });
    });
  }

  function ensureProductStoryStyles() {
    if (document.getElementById("harp-dry-pdp-primer-styles")) return;

    const style = document.createElement("style");
    style.id = "harp-dry-pdp-primer-styles";
    style.textContent = `
      .harp-dry-pdp-primer{margin:16px 0 14px;padding:18px;border:1px solid #dfe5ee;border-radius:15px;background:#f8fafc;color:#172348}
      .harp-dry-pdp-primer__kicker{margin:0 0 8px;color:#334966;font-size:12px;font-weight:900;letter-spacing:.09em;line-height:1.45;text-transform:uppercase}
      .harp-dry-pdp-primer__copy{margin:0;color:#334158;font-size:16px;line-height:1.58}
      .harp-dry-pdp-primer__compare{display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-top:13px}
      .harp-dry-pdp-primer__cell{display:flex;min-width:0;flex-direction:column;padding:11px 12px;border:1px solid;border-radius:10px}
      .harp-dry-pdp-primer__cell span{font-size:12px;font-weight:900;letter-spacing:.04em;line-height:1.35;text-transform:uppercase}
      .harp-dry-pdp-primer__cell strong{margin-top:2px;font-size:18px;line-height:1.15;letter-spacing:-.02em}
      .harp-dry-pdp-primer__cell small{margin-top:3px;color:#3d4b61;font-size:12px;font-weight:650;line-height:1.4}
      .harp-dry-pdp-primer__cell--soap{border-color:#ead4c7;background:#fff7f2;color:#6a3a25}
      .harp-dry-pdp-primer__cell--harp{border-color:#bfd9f4;background:#edf6ff;color:#173b65}
      .harp-dry-pdp-primer__note{margin:11px 0 0;color:#405068;font-size:14px;line-height:1.55}
      @media(max-width:749px){
        .harp-dry-pdp-primer{margin:12px 0 11px;padding:14px}
        .harp-dry-pdp-primer__kicker{font-size:12px;letter-spacing:.075em}
        .harp-dry-pdp-primer__copy{font-size:14px;line-height:1.55}
        .harp-dry-pdp-primer__compare{gap:8px}
        .harp-dry-pdp-primer__cell{padding:9px}
        .harp-dry-pdp-primer__cell span{font-size:11px;letter-spacing:.025em}
        .harp-dry-pdp-primer__cell strong{font-size:16px}
        .harp-dry-pdp-primer__cell small{font-size:12px;line-height:1.38}
        .harp-dry-pdp-primer__note{font-size:13px;line-height:1.52}
      }
    `;
    document.head.appendChild(style);
  }

  function injectProductStory() {
    const productWrapper = document.querySelector(".harp-ff-product[data-product-handle]");
    if (!productWrapper) return;

    const handle = productWrapper.getAttribute("data-product-handle");
    const story = PRODUCT_STORIES[handle];
    if (!story) return;

    const intro = productWrapper.querySelector(".harp-ff-intro");
    if (!intro) return;

    const subtitle = intro.querySelector(".harp-ff-subtitle");
    if (subtitle && subtitle.textContent.trim() !== story.subtitle) {
      subtitle.textContent = story.subtitle;
      subtitle.dataset.harpProductStoryUpdated = "true";
    }

    if (productWrapper.querySelector(".harp-dry-pdp-primer")) return;

    ensureProductStoryStyles();

    const primer = document.createElement("div");
    primer.className = "harp-dry-pdp-primer";
    primer.dataset.harpProductStory = handle;
    primer.innerHTML = `
      <p class="harp-dry-pdp-primer__kicker">${story.kicker}</p>
      <p class="harp-dry-pdp-primer__copy">${story.copy}</p>
      <div class="harp-dry-pdp-primer__compare" aria-label="Traditional soap and HARP pH comparison">
        <div class="harp-dry-pdp-primer__cell harp-dry-pdp-primer__cell--soap"><span>Traditional soap</span><strong>pH 9–11</strong><small>Alkaline by nature</small></div>
        <div class="harp-dry-pdp-primer__cell harp-dry-pdp-primer__cell--harp"><span>HARP®</span><strong>pH 5.0–6.0</strong><small>Soap-free 100% syndet</small></div>
      </div>
      <p class="harp-dry-pdp-primer__note">${story.note}</p>
    `;
    const buyingEnd = productWrapper.querySelector("[data-harp-buying-end]");
    if (buyingEnd) buyingEnd.insertAdjacentElement("afterend", primer);
  }

  function moveReviewsForMobile() {
    if (!mobileQuery.matches) return;

    const reviewSection = document.querySelector('[id*="17680941625c8782be"]');
    const detailsSection = document.querySelector(".harp-fragrance-free-details-section");

    if (!reviewSection || !detailsSection) return;
    if (reviewSection.classList.contains("harp-mobile-review-section")) return;

    detailsSection.insertAdjacentElement("beforebegin", reviewSection);
    reviewSection.classList.add("harp-mobile-review-section");
  }

  function collapseDeepEducationForMobile() {
    if (!mobileQuery.matches) return;

    const detailsRoot = document.querySelector(".harp-ff-details");
    if (!detailsRoot || detailsRoot.querySelector(":scope > .harp-ff-mobile-deep-dive")) return;

    const sections = Array.from(detailsRoot.querySelectorAll(":scope > .harp-ff-section"));
    if (sections.length < 5) return;

    const deepSections = sections.slice(3);
    const disclosure = document.createElement("details");
    disclosure.className = "harp-ff-mobile-deep-dive";

    const summary = document.createElement("summary");
    summary.textContent = "Ingredients, how to use, FAQs & quality details";
    disclosure.appendChild(summary);

    sections[2].insertAdjacentElement("afterend", disclosure);
    deepSections.forEach((section) => disclosure.appendChild(section));
  }

  function initializeMobileConversionLayout() {
    if (!mobileQuery.matches) return;
    moveReviewsForMobile();
    collapseDeepEducationForMobile();
  }

  function initializePackCards() {
    document.querySelectorAll(".harp-buying-layout").forEach((wrapper) => {
      if (wrapper.dataset.harpCardsReady) return;
      wrapper.dataset.harpCardsReady = "true";
      let queued = false;
      const sync = () => {
        queued = false;
        const widget = wrapper.querySelector(".appstle_sub_widget");
        const selected = widget?.querySelector('input[name="selling_plan"]:checked');
        const subscription = selected && !selected.closest(".appstle_one_time_details_wrapper");
        wrapper.dataset.harpSubscription = subscription ? "true" : "false";
        const planId = subscription
          ? widget.querySelector("select.appstle_select")?.value || selected.value || selected.dataset.appstleRealValue || ""
          : "";
        wrapper.querySelectorAll(".harp-pack-card").forEach((card) => {
          const prices = Array.from(card.querySelectorAll("[data-harp-plan-price]"));
          const chosen = prices.find((item) => item.dataset.harpPlanPrice === planId) || prices[0];
          prices.forEach((item) => {
            const hidden = item !== chosen;
            if (item.hidden !== hidden) item.hidden = hidden;
          });
        });
        const selectedInput = wrapper.querySelector('.harp-pack-options input:checked');
        const selectedCard = selectedInput?.nextElementSibling;
        const activeAmount = selectedCard?.querySelector('[data-harp-plan-price]:not([hidden]) .harp-pack-card__price');
        const total = wrapper.querySelector('.harp-order-price');
        if (total && activeAmount) {
          const amount = activeAmount.textContent.trim();
          if (total.textContent.trim() !== amount) total.textContent = amount;
          total.hidden = false;
          wrapper.dataset.harpCardPrices = 'true';
        }
      };
      const schedule = () => {
        if (!queued) {
          queued = true;
          window.requestAnimationFrame(sync);
        }
      };
      wrapper.addEventListener("change", schedule);
      wrapper.addEventListener("variantChangeEnd", schedule);
      wrapper.addEventListener("keydown", (event) => {
        const card = event.target.closest(".harp-pack-card");
        if (!card || ![" ", "Enter", "ArrowRight", "ArrowLeft", "ArrowDown", "ArrowUp"].includes(event.key)) return;
        event.preventDefault();
        const labels = Array.from(wrapper.querySelectorAll(".harp-pack-card"));
        let target = card;
        if (event.key.startsWith("Arrow")) {
          const offset = ["ArrowRight", "ArrowDown"].includes(event.key) ? 1 : -1;
          target = labels[(labels.indexOf(card) + offset + labels.length) % labels.length];
        }
        target.focus();
        document.getElementById(target.htmlFor)?.click();
      });
      const observer = new MutationObserver(schedule);
      observer.observe(wrapper, { childList: true, subtree: true, attributes: true, attributeFilter: ["checked", "value"] });
      sync();
    });
  }

  function initialize() {
    initializeStickyButton();
    initializePackCards();
    injectProductStory();
    initializeMobileConversionLayout();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", () => {
    window.setTimeout(() => {
      injectProductStory();
      initializePackCards();
      initializeMobileConversionLayout();
    }, 50);
  });
})();
